import { API_ENDPOINTS } from '../../config';
import { getBearerAuthHeaders } from '../../utils/authFetchHeaders';

/** Hard cap on dashboards per user. Mirrors MAX_DASHBOARDS_PER_USER in server/routes/dashboards.js. */
export const MAX_DASHBOARDS = 5;

export async function apiListDashboards() {
  const resp = await fetch(API_ENDPOINTS.dashboards, { headers: getBearerAuthHeaders() });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.dashboards || [];
}

export async function apiGetDashboard(id) {
  const resp = await fetch(API_ENDPOINTS.dashboardById(id), { headers: getBearerAuthHeaders() });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.dashboard;
}

export async function apiCreateDashboard(payload) {
  const resp = await fetch(API_ENDPOINTS.dashboards, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getBearerAuthHeaders() },
    body: JSON.stringify(payload),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.dashboard;
}

export async function apiUpdateDashboard(id, payload) {
  const resp = await fetch(API_ENDPOINTS.dashboardById(id), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getBearerAuthHeaders() },
    body: JSON.stringify(payload),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.dashboard;
}

export async function apiDeleteDashboard(id) {
  const resp = await fetch(API_ENDPOINTS.dashboardById(id), {
    method: 'DELETE',
    headers: getBearerAuthHeaders(),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data;
}

export async function apiGetDefaultTemplate() {
  const resp = await fetch(API_ENDPOINTS.dashboardDefaultTemplate, { headers: getBearerAuthHeaders() });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.template || { layout: null, widgets: [], published_at: null };
}

export async function apiPutDefaultTemplate(payload) {
  const resp = await fetch(API_ENDPOINTS.dashboardDefaultTemplate, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getBearerAuthHeaders() },
    body: JSON.stringify(payload),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data?.success) throw new Error(data?.error || `Failed (${resp.status})`);
  return data.template;
}
